'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeResize = exports.addResize = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                              * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                              * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                              */


var _spauiUtils = require('@tencent/spaui-utils');

// 是否jquery
var haveJQuery = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && typeof window.jQuery === 'function';

// 添加resize
var addResize = exports.addResize = function addResize(resizeCallback) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    if (target) {
        if (haveJQuery) {
            jQuery(target).on('resize', resizeCallback);
        } else if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && (0, _spauiUtils.isFunction)(target.addEventListener)) {
            target.addEventListener('resize', resizeCallback);
        }
    }
};

// 去除resize
var removeResize = exports.removeResize = function removeResize(resizeCallback) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    if (target) {
        if (haveJQuery) {
            jQuery(target).off('resize', resizeCallback);
        } else if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && (0, _spauiUtils.isFunction)(target.removeEventListener)) {
            target.removeEventListener('resize', resizeCallback);
        }
    }
};

exports.default = {
    addResize: addResize,
    removeResize: removeResize
};